export default "__VITE_ASSET__BKU93kaH__"